var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.543.667a5.877 5.877 0 1 0 3.496 10.601l3.81 3.81a.869.869 0 1 0 1.23-1.228l-3.812-3.81A5.877 5.877 0 0 0 6.543.666Zm-4.14 5.877a4.14 4.14 0 1 1 8.28 0 4.14 4.14 0 0 1-8.28 0Z",
    fill: "currentColor"
  })));
};
export default SvgSearch;